import React, { forwardRef } from "react";

const Checkbox = forwardRef(
  ({
    checkBoxRef,
    props,
    label,
    className,
    type,
    value,
    id,
    name,
    disabled,
    onChange,
    index,
  }) => {
    return (
      <div className={`form-check ${className}`}>
        <input
          className="form-check-input border-blue"
          type={type}
          value={value}
          id={id}
          name={name}
          ref={checkBoxRef}
          {...props}
          disabled={disabled}
          // onChange={onChange}
          onChange={(e) => onChange && onChange(e, index)}
        />
        <label className="form-check-label text-blue" htmlFor={id}>
          {label}
        </label>
      </div>
    );
  }
);

export default Checkbox;
